import { render } from "./PrettifyJSON.vue?vue&type=template&id=399d7b8a&ts=true"
import script from "./PrettifyJSON.vue?vue&type=script&lang=ts"
export * from "./PrettifyJSON.vue?vue&type=script&lang=ts"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__